var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMessageHistory = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7916 20.4166H10.3333C6.66659 20.4166 4.83325 19.4999 4.83325 14.9166V10.3333C4.83325 6.66659 6.66659 4.83325 10.3333 4.83325H17.6666C21.3333 4.83325 23.1666 6.66659 23.1666 10.3333V14.9166C23.1666 18.5833 21.3333 20.4166 17.6666 20.4166H17.2083C16.9241 20.4166 16.6491 20.5541 16.4749 20.7833L15.0999 22.6166C14.4949 23.4233 13.5049 23.4233 12.8999 22.6166L11.5249 20.7833C11.3783 20.5816 11.0391 20.4166 10.7916 20.4166Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6635 13.0833H17.6717",
    stroke: "#7A7A7A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9958 13.0833H14.004",
    stroke: "#7A7A7A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3283 13.0833H10.3365",
    stroke: "#7A7A7A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMessageHistory);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-message-history.6da659622571bae94167a147cc5cb59d.svg";